import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import useModalities from '@core/hooks/useModalities';
import { ModalityModel } from '@core/types';

interface ModalityDropdownProps {
  handleSelectedModality: (modality?: ModalityModel) => void;
}

const ModalityDropdown: React.FC<ModalityDropdownProps> = ({ handleSelectedModality }) => {
  const [selectedModalityId, setSelectedModalityId] = useState<number>(-1);
  const { modalities, isLoading } = useModalities();

  const handleModalitySelection = (e: SelectChangeEvent<number>) => {
    const modalityId = Number(e.target.value);

    if (isNaN(modalityId)) return;

    setSelectedModalityId(modalityId);

    const modality = modalities?.result.find((s) => s.modalityId === modalityId);

    handleSelectedModality(modality);
  };

  const itemsPlaceholder = isLoading
    ? 'Cargando modalidades...'
    : modalities?.result.length === 0
    ? 'Sin modalidades'
    : 'Selecciona una modalidad';

  return (
    <Select
      displayEmpty
      inputProps={{ 'aria-label': 'Selecciona una modalidad' }}
      value={selectedModalityId}
      onChange={handleModalitySelection}
    >
      <MenuItem value={-1}>{itemsPlaceholder}</MenuItem>
      {modalities?.result.map((modality) => (
        <MenuItem key={modality.modalityId + (modality.name || '')} value={modality.modalityId}>
          {modality.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ModalityDropdown;
